import { render } from '@testing-library/react';
import React, { Component, useEffect, useState, useLayoutEffect } from 'react'
import { Link, useLocation } from 'react-router-dom';
import { GeoserverGetCapabilities } from '../../services/geoserver/GeoserverCapabilities';
import Meses from '../../services/Meses';
import ValoresApi from '../../services/robinhood/ValoresApi';
import CategoriasApi from '../../services/robinhood/CategoriasApi';

export default function MenuExtratoComparativoTransferencia(props) {

    const meses = Meses;
    const [layers, setLayers] = useState([]);
    const [groups, setGroups] = useState([]);
    const [workspaces, setWorkspaces] = useState([]);
    const [menu, setMenu] = useState(null);
    const [anos, setAnos] = useState([]);
    const categoria = { transferencias: 2 };
    const [indicadores, setIndicadores] = useState([]);
    const [anoSelecionado, setAnoSelecionado] = useState(localStorage.getItem('ano_selecionado') || new Date().getFullYear());
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        start();
    }, [])

    useEffect(() => {
        const handleStorageChange = () => {
            const novoAno = localStorage.getItem('ano_selecionado');
            if (novoAno && novoAno !== anoSelecionado) {
                setAnoSelecionado(novoAno);
                carregarIndicadores(novoAno);
            }
        };

        window.addEventListener('storage', handleStorageChange);

        const interval = setInterval(() => {
            const anoAtual = localStorage.getItem('ano_selecionado');
            if (anoAtual && anoAtual !== anoSelecionado) {
                setAnoSelecionado(anoAtual);
                carregarIndicadores(anoAtual);
            }
        }, 500);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
            clearInterval(interval);
        };
    }, [anoSelecionado])

    useEffect(() => {
        if (anoSelecionado) {
            carregarIndicadores(anoSelecionado);
        }
    }, [anoSelecionado])

    const start = async () => {
        new ValoresApi().anos().then(response => {
            const anosMap = response.map(ano => ano.ano);
            setAnos(anosMap.reverse());
        });
    }

    const carregarIndicadores = async (_ano) => {
        setLoading(true);
        new CategoriasApi().indicadoresComValoresPorAno(categoria.transferencias, _ano).then(response => {
            setIndicadores(response);
            setLoading(false);
        }).catch(error => {
            console.error('Erro ao carregar indicadores:', error);
            setLoading(false);
        });
    }

    const handlerMenu = (_indicador_id) => {
        if (menu != _indicador_id)
            setMenu(_indicador_id);
    }

    const CatalogItem = (props) => {
        return (
            <>
                {loading ? (
                    <div className="text-center" style={{ padding: '20px' }}>
                        <i className="zmdi zmdi-spinner zmdi-hc-spin" style={{ fontSize: '24px', color: '#8BC34A' }}></i>
                        <p className="text-muted small m-t-10">Carregando Critérios...</p>
                    </div>
                ) : (
                    <ul className="ml-menu" style={{ display: 'block' }}>
                        {indicadores.map(indicador => <li key={Math.random()} className={menu == indicador.id ? 'active' : ''} > <Link to={'/extratos/comparativo/transferencia'} key={Math.random()} state={{ indicador: { 'id': indicador.id, 'indicador': indicador.indicador, 'nome': indicador.nome }, 'key': Math.random() }} className="waves-effect waves-classic" style={{ fontWeight: '', fontSize: '14px', paddingTop: '2px', paddingBottom: '2px' }} onClick={() => handlerMenu(indicador.id)} > <span> {indicador.nome} </span> </Link></li>)}
                        <li key={Math.random()} className={menu == 10000 ? 'active' : ''} >
                            <Link to={'/extratos/comparativo/transferencia'} key={Math.random()} state={{ indicador: { 'id': 10000, 'indicador': 'transferencias_total', 'nome': 'Transferências Total' }, 'key': Math.random() }} className="waves-effect waves-classic" style={{ fontWeight: '', fontSize: '14px', paddingTop: '2px', paddingBottom: '2px' }} onClick={() => handlerMenu(10000)} > <span> Transferências total  </span>
                            </Link>
                        </li>
                    </ul>
                )}
            </>
        );
    }

    return (
        <>
            <div className="menu">
                <ul className="list">
                    <li className="header"><strong> <i className='zmdi zmdi-view-list m-r-5'></i>  &nbsp;CRITÉRIOS </strong></li>
                    <CatalogItem></CatalogItem>
                </ul>
            </div>
        </>
    );

}
